import type { FormControlSetting } from '@/app/editor/iframe/atom/Atom.model';

import { GpThirdParty } from '@/app/editor/iframe/atom/third-party/GpThirdParty';
import { AtomServiceExportData } from '../atom-service/export/AtomServiceExportData';

declare let Liquid: any;

const FormControlSettings: Array<FormControlSetting> = [
  {
    type: 'custom:align',
    name: 'alignment',
    targetSelector: '.module',
    property: '',
  },
  {
    type: 'html:attr',
    name: 'arv6picker',
    property: 'data-arv6picker',
    targetSelector: '.module',
    default_value: '',
  },
  {
    type: 'html:attr',
    name: 'v6widget',
    property: 'data-widget',
    refreshType: 'all',
    targetSelector: '.module',
    default_value: 'section',
    options: [
      {
        key: 'section',
        value: 'Section',
      },
      {
        key: 'badge',
        value: 'Star Badge',
      },
      {
        key: 'badgeCollection',
        value: 'Star Badge in Collection',
      },
    ],
  },
  {
    type: 'html:extraClass',
    name: 'extra_class',
    targetSelector: '.module',
    property: 'data-exc',
    default_value: '',
  },
];
/**
 * GpElementExportService
 */
export class GpAliReviewsExportService extends AtomServiceExportData {
  /**
   * renderTemplateExport
   * @param $atomClone atomClone
   * @param html html
   * @returns
   */
  renderTemplateExport($atomClone: JQuery, html: string): JQuery {
    const $snippet = this.atom.getDataSnippetByKey();
    const $template = $snippet.find('.template');
    if ($template.length > 0) {
      html = $template.html();
    }
    html = this.atom.atomRender.renderSettings(html);
    if (this.atom.$el.attr('data-compile') != 'false' && this.atom.getLabel() != 'Liquid') {
      const tmpl = Liquid.parse(html);
      html = tmpl.render({
        items: this.atom.data.atom.data['items'],
      });
    }
    return $atomClone.html(html);
  }
}
/**
 * Hero Banner Atom Module
 */
export class GpAliReviews extends GpThirdParty {
  public $el: JQuery;

  /**
   * override getLabel từ Atom
   * @returns Name
   */
  getLabel(): string {
    return this.$el.attr('data-label') || 'Ali Reviews';
  }
  /**
   * override getLabel từ Atom
   * @returns Slug
   */
  getSlug(): string {
    return this.$el.attr('data-slug') || 'ali-reviews';
  }
  /**
   * getFormControlSettings;
   * @returns setting read/write from left-sidebar to live page
   */
  getFormControlSettings(): Array<FormControlSetting> {
    return FormControlSettings;
  }
  /**
   * check
   * @returns true: change setting after drag
   */
  isAutoRenderSetting() {
    return true;
  }

  initAtomExport() {
    this.atomServiceExportData = new GpAliReviewsExportService(this);
  }
}
